import { createContext } from 'react';
import { SxProps, Theme } from '@mui/material';
import { HEADER_ACCENT_STYLES } from '../header-accent-styles';
import { ReemaThemeV2 } from '../reema-theme-V2';

export type HeaderAccentStyleKey = keyof typeof HEADER_ACCENT_STYLES;
export type ThemeKey = keyof typeof ReemaThemeV2;

export interface SettingsContextType {
  theme:
    | typeof ReemaThemeV2.LIGHT_MODE
    | typeof ReemaThemeV2.DARK_MODE
    | typeof ReemaThemeV2.COLOR_BLIND_MODE;
  themeKey: ThemeKey;
  setThemeKey: (themeKey: ThemeKey) => void;
  currentHeaderAccentStyle: SxProps<Theme>;
  headerAccentStyleKey: HeaderAccentStyleKey;
  isHeaderAccentAnimationEnabled: boolean;
  setHeaderAccentStyleKey: (headerAccentStyleKey: HeaderAccentStyleKey) => void;
  setIsHeaderAccentAnimationEnabled: (
    isHeaderAccentAnimationEnabled: boolean
  ) => void;
}

export const SettingsContext = createContext<SettingsContextType>({
  theme: ReemaThemeV2.LIGHT_MODE,
  themeKey: 'LIGHT_MODE',
  setThemeKey: () => {},
  currentHeaderAccentStyle: HEADER_ACCENT_STYLES.none,
  headerAccentStyleKey: 'none',
  isHeaderAccentAnimationEnabled: false,
  setHeaderAccentStyleKey: () => {},
  setIsHeaderAccentAnimationEnabled: () => {},
});
